import { render, staticRenderFns } from "./mySnackbar.vue?vue&type=template&id=5b3f95ff&scoped=true&"
import script from "./mySnackbar.vue?vue&type=script&lang=js&"
export * from "./mySnackbar.vue?vue&type=script&lang=js&"
import style0 from "./mySnackbar.vue?vue&type=style&index=0&id=5b3f95ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f95ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCardActions})
